import { render, staticRenderFns } from "./ExporPersonal.vue?vue&type=template&id=971643e2&scoped=true&"
import script from "./ExporPersonal.vue?vue&type=script&lang=js&"
export * from "./ExporPersonal.vue?vue&type=script&lang=js&"
import style0 from "./ExporPersonal.vue?vue&type=style&index=0&id=971643e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971643e2",
  null
  
)

export default component.exports